module.exports = __webpack_public_path__ + "static/media/Vaishnavi Pabalkar.922f6744.jpeg";